import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import SavingsSection from './components/SavingsSection';
import ServiceCards from './components/ServiceCards';
import VirtualQuoteSection from './components/VirtualQuoteSection';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ServicesHero />
        <SavingsSection />
        <VirtualQuoteSection />
        <ServiceCards />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
